import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { CheckoutActions } from 'store/pages/checkout'
import { initSeats } from 'store/pages/event/actions/initSeats'
import { showEventFees } from 'store/pages/event/actions/showEventFees'
import { initialState } from 'store/pages/event/state'
import { getBulkEventIdsKey } from 'helpers/event/ids'

import { fetchMetadata } from '../actions/fetchMetadata'
import { getBulkData } from '../actions/getBulkData'
import { getData } from '../actions/getData'
import { getGoods } from '../actions/getGoods'

export const EventSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {
    setFreeEvent: (state, action: PayloadAction<{ isEventFree: boolean }>) => {
      const { isEventFree } = action.payload
      return {
        ...state,
        isEventFree: isEventFree,
      }
    },
    setEndedEvent: (state, action: PayloadAction<{ isEventEnded: boolean }>) => {
      const { isEventEnded } = action.payload
      return {
        ...state,
        isEventEnded: isEventEnded,
      }
    },
    closeEventFees: (state) => {
      state.fees.visibleEventCodeUrl = undefined
    },
  },
  extraReducers: (builder) => {
    builder.addCase(initSeats.fulfilled, (state, action) => {
      const { id, sectionsEnabled, sectors, seatsBusy, linkedSeats } = action.payload

      const seats = state.seats[id] || {}

      return {
        ...state,
        seats: { ...state.seats, [id]: { ...seats, seatsBusy, linkedSeats, sectionsEnabled, sectors } },
      }
    })

    builder.addCase(showEventFees.pending, (state, action) => {
      const { codeUrl, typeTicketCollectionId } = action.meta.arg
      state.fees.visibleEventCodeUrl = codeUrl
      state.fees.visibleEventTypeTicketCollectionId = typeTicketCollectionId
    })

    builder.addCase(showEventFees.fulfilled, (state, action) => {
      const { codeUrl } = action.meta.arg
      state.fees.events[codeUrl] = action.payload
    })

    builder.addCase(getGoods.pending, (state, action) => {
      const { codeUrl } = action.meta.arg
      state.goods.visibleEventCodeUrl = codeUrl
    })

    builder.addCase(getGoods.fulfilled, (state, action) => {
      const { codeUrl } = action.meta.arg
      state.goods.events[codeUrl] = action.payload
    })

    builder.addCase(fetchMetadata.fulfilled, (state, action) => {
      const { metadata } = action.payload
      state.metadata = metadata
    })

    builder.addCase(CheckoutActions.close, (state) => {
      delete state.seats['checkout']
    })

    builder.addCase(getData.fulfilled, (state, action) => {
      const data = action.payload
      state.data.events[data.codeUrl] = data
      state.data.events[data.code] = data
      state.data.events[data.id] = data
    })

    builder.addCase(getBulkData.fulfilled, (state, action) => {
      const idsOrCodeUrls = action.meta.arg.idsOrCodeUrls
      const eventIdsKey = getBulkEventIdsKey(idsOrCodeUrls)

      action.payload.forEach((event) => {
        state.data.events[event.id] = event
        state.data.events[event.code] = event
        state.data.events[event.codeUrl] = event
      })
      
      state.data.bulk.locationIds[eventIdsKey] = action.payload
        .filter((x) =>
          idsOrCodeUrls.includes(String(x.id)) ||
          idsOrCodeUrls.includes(String(x.code)) ||
          idsOrCodeUrls.includes(String(x.codeUrl)))
        .map((x) => x.locationId)
    })
  },
})
